import React, { FC, memo, useCallback } from 'react'

import { clsx } from 'clsx'

import { ShopTipVariant } from 'Types'

interface Props {
  applyTipVariant({ amount, id }: { amount: number; id: string | undefined }): void
  tipVariant: ShopTipVariant
  tipVariantId?: string
}

const TipVariantBtn: FC<Props> = ({ tipVariantId, tipVariant, applyTipVariant }) => {
  const isActive = tipVariantId === tipVariant.id
  const handleClick = useCallback(
    () =>
      isActive
        ? applyTipVariant({ amount: 0, id: undefined })
        : applyTipVariant({ amount: tipVariant.amount, id: tipVariant.id }),
    [applyTipVariant, isActive, tipVariant.amount, tipVariant.id],
  )

  return (
    <button
      className={clsx('tips__btn / btn btn-accent / text-uppercase', {
        tips__btn_active: isActive,
      })}
      type="button"
      onClick={handleClick}
    >
      <b>{tipVariant.percentage}%</b>
      <span>{tipVariant.amountFormatted}</span>
    </button>
  )
}
export default memo(TipVariantBtn)
